import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { GenericService } from '../../commons/generic.service';
import { EntidadeDevedora } from 'src/app/interface/entidade';
import {PrecatorioPagoDTO} from "../../../models/precatorioPagoDTO";

@Injectable({
    providedIn: 'root'
})
export class EntidadeService extends GenericService {
    private relativePath = 'api/entidade-devedora/';
   
    constructor(http: HttpClient) {
        super(http);
    }

    listEnteDevedor(): Observable<any[]>{
        return this.getMethod(this.relativePath);
    }

    listEntidadeDevedora(cdEntidadeDevedora:number): Observable<any[]>{
        return this.getMethod(this.relativePath + cdEntidadeDevedora + '/' + 'entidade-requerida');
    }

    buscarListaPorFiltro(filtro:any): Observable<any> { 
     
        return this.getMethod(this.relativePath + 'precatorios',
            filtro
           );
    }

    buscarTodosPorFiltro(filtro:any): Observable<any> { 
     
        return this.getMethod(this.relativePath + 'precatorios/all',
            filtro        
           );
    }

    obterRelatorio(filtro:any): Observable<ArrayBuffer> { 
        var headers = this.getHeaders();
        headers = headers.set('Accept', 'application/octet-stream');
        return this.http.get<ArrayBuffer>(this.url + this.relativePath + "report",  {headers: headers, responseType: 'blob' as 'json' , params: filtro});
        
      
    }
    buscarPrecatoriosPagosPorFiltro(filtro:any): Observable<any> {

        return this.getMethod(this.relativePath + 'precatorios/pagos',filtro);
    }




}
